export enum ReceiveBrochureEnum {
  EMAIL = 'EMAIL',
  EMAIL_AND_COURIER = 'EMAIL_AND_COURIER'
}

export const receiveBrochureEnumMapping: Record<ReceiveBrochureEnum, string> = {
  [ReceiveBrochureEnum.EMAIL]: 'Recevoir la brochure par e-mail uniquement',
  [ReceiveBrochureEnum.EMAIL_AND_COURIER]: 'Recevoir la brochure par courrier et par e-mail'
}
